import React from 'react';

const KpiNotificationsIcon = () => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<path
				d='M20.25 20.25H3.75'
				stroke='#4D4DB3'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.75 3H6C5.58579 3 5.25 3.33579 5.25 3.75V16.5C5.25 16.9142 5.58579 17.25 6 17.25H9.75C10.1642 17.25 10.5 16.9142 10.5 16.5V3.75C10.5 3.33579 10.1642 3 9.75 3Z'
				fill='#4D4DB3'
				stroke='#4D4DB3'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M13.5 7.55V16.598C13.5 16.9581 13.7919 17.25 14.152 17.25C14.512 17.25 14.8028 16.9574 14.8102 16.5974C14.8531 14.5032 15.1136 13.8451 15.5329 13.2938C15.9152 12.791 16.7297 12.1027 17.9537 11.8847C18.3887 11.8072 18.75 11.4573 18.75 11.0155V7.55C18.75 7.10817 18.3918 6.75 17.95 6.75H14.3C13.8582 6.75 13.5 7.10817 13.5 7.55Z'
				fill='#4D4DB3'
				stroke='#4D4DB3'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<g clipPath='url(#clip0_71_550772)'>
				<path
					d='M17.875 17.666H19.125'
					stroke='#4D4DB3'
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth='0.5'
				/>
				<path
					d='M17.0981 15.0313C17.0978 14.846 17.1342 14.6626 17.2052 14.4915C17.2761 14.3203 17.3802 14.165 17.5115 14.0342C17.6427 13.9035 17.7985 13.8001 17.9699 13.7299C18.1413 13.6596 18.325 13.624 18.5102 13.625C19.2836 13.6309 19.9028 14.2735 19.9028 15.0489V15.1875C19.9028 15.8867 20.0493 16.293 20.1782 16.5156C20.1919 16.5394 20.1991 16.5663 20.1991 16.5936C20.1991 16.621 20.1919 16.6479 20.1783 16.6717C20.1646 16.6954 20.145 16.7151 20.1213 16.7289C20.0977 16.7426 20.0708 16.7499 20.0434 16.75H16.9575C16.9301 16.7499 16.9032 16.7426 16.8795 16.7289C16.8558 16.7151 16.8362 16.6954 16.8226 16.6717C16.8089 16.6479 16.8017 16.621 16.8018 16.5936C16.8018 16.5663 16.809 16.5394 16.8227 16.5156C16.9516 16.293 17.0981 15.8867 17.0981 15.1875V15.0313Z'
					fill='#2E2E6B'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth='0.5'
				/>
			</g>
			<defs>
				<clipPath id='clip0_71_550772'>
					<rect
						fill='white'
						height='5'
						transform='translate(16 13)'
						width='5'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default KpiNotificationsIcon;
